"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WorkspaceReservationFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_WorkspaceReservationFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1v3c0 .553-.447 1-1 1H1c-.553 0-1-.447-1-1V1c0-.553.447-1 1-1h5.5c.553 0 1 .447 1 1ZM16 1v3c0 .553-.447 1-1 1H9.5c-.553 0-1-.447-1-1V1c0-.553.447-1 1-1H15c.553 0 1 .447 1 1Zm0 6v3c0 .553-.447 1-1 1H9.5c-.553 0-1-.447-1-1V7c0-.553.447-1 1-1H15c.553 0 1 .447 1 1Zm-9.06 3.957a.56.56 0 0 0-.56.56v-.56a.56.56 0 1 0-1.12 0v-.28a.56.56 0 1 0-1.12 0V8.713a.56.56 0 1 0-1.12 0v3.22a.44.44 0 0 1-.253.397.409.409 0 0 1-.46-.063c-.524-.46-.954-.73-1.224-.764-.3-.033-.586.11-.586.43 0 .11.046.207.143.304a8.076 8.076 0 0 1 1.857 2.143A3.358 3.358 0 0 0 5.387 16a2.11 2.11 0 0 0 2.11-2.11v-2.373a.56.56 0 0 0-.56-.56h.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6H1c-.553 0-1 .447-1 1v3a1 1 0 0 0 1 1h.523a.5.5 0 1 0 0-1H1V7h5.5v2.63a.5.5 0 1 0 1 0V7c0-.553-.447-1-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_WorkspaceReservationFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = WorkspaceReservationFill;
exports["default"] = _default;